<template>
	<div>
		<form @submit.prevent="search">
			<div class="search-container u-container">
				<div class="search-item search-item--date">
					<input
						v-model="inputStartDate"
						@click="openCalendar"
						type="text"
						autocomplete="off"
						readonly
					/>
					<i class="ri-calendar-line"></i>
				</div>
				<div class="search-item search-item--text">~</div>
				<div class="search-item search-item--date">
					<input
						v-model="inputEndDate"
						@click="openCalendar"
						type="text"
						autocomplete="off"
						readonly
					/>
					<i class="ri-calendar-line"></i>
				</div>
				<div class="search-item search-item--button">
					<BaseBtn color="primary" type="submit" medium block>조회</BaseBtn>
				</div>
			</div>
		</form>

		<div
			:class="{ 'is-open': isOpenCalendar }"
			class="search-calender-container"
		>
			<VCalendar
				@callbackSelectedDate="callbackSelectedDate"
				:isRange="true"
				:isExpanded="true"
			></VCalendar>
		</div>
	</div>
</template>

<script>
import BaseBtn from '@/components/common/Btn';
import VCalendar from '@/components/common/VCalendar';

import { formatDate } from '@/utils/util';

export default {
	components: {
		BaseBtn,
		VCalendar,
	},
	props: {
		startDate: {
			type: Date,
			default: () => new Date(),
		},
		endDate: {
			type: Date,
			default: () => new Date(),
		},
	},
	data() {
		return {
			dateRange: {
				start: new Date(),
				end: new Date(),
			},
			isOpenCalendar: false,
		};
	},
	computed: {
		inputStartDate: {
			get() {
				return formatDate(this.dateRange.start);
			},
			set(val) {
				this.dateRange.start = val;
			},
		},
		inputEndDate: {
			get() {
				return formatDate(this.dateRange.end);
			},
			set(val) {
				this.dateRange.end = val;
			},
		},
	},
	created() {
		this.dateRange.start = this.startDate;
		this.dateRange.end = this.endDate;
	},
	mounted() {
		this.$emit('search', this.dateRange);
	},
	methods: {
		search() {
			this.$emit('search', this.dateRange);
		},
		callbackSelectedDate(date) {
			this.dateRange = date;
			this.closeCalendar();
		},
		openCalendar() {
			this.isOpenCalendar = true;
		},
		closeCalendar() {
			this.isOpenCalendar = false;
		},
	},
};
</script>

<style scoped>
.search-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	padding: 1rem 0;
}

.search-item--date {
	display: flex;
	justify-content: space-between;
	flex: 0 0 35%;
	border-bottom: 1px solid #c8c8c8;
}

.search-item--date input[type='text'],
.search-item--date i {
	height: 2.5rem;
}

.search-item--date input[type='text'] {
	width: 100%;
	padding: 0 0.3125rem;
	border: 0;
	font-size: 0.875rem;
}

.search-item--date i {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0.3125rem;
	color: #c8c8c8;
	font-size: 1.375rem;
	cursor: pointer;
}

.search-item--text {
	flex: 1;
	color: #222;
	font-size: 1.25rem;
	text-align: center;
}

.search-item--button {
	flex: 0 0 20%;
	padding-left: 0.875rem;
}

.search-item--button button {
	width: 100%;
	height: 100%;
}

.search-calender-container {
	display: none;
	position: fixed;
	left: 0;
	right: 0;
	z-index: 5000;
	bottom: 3.75rem;
}

.search-calender-container.is-open {
	display: block;
}
</style>
